export function sanitizeSelectorToName(selector: string): string {
  return `${selector
    .replace(/ /g, `_`)
    .replace(/[^a-zA-Z0-9_]+/g, `_`)
    .replace(/^_+|_+$/g, ``)}`;
}
